import { createLanguageTV } from "../../../models/language.model";

export const createUserDetails = (data = {}) => {
  const usr = data.usr || {};
  const loading = data.loading || false;
  const languages = data.languages || [];
  const languagesTV = createLanguageTV(languages);
  const allPerm = data.allPerm || {};
  const userPerm = data.userPerm || {};
  const blocked = userPerm.blocked || {};

  return {
    ...data,
    usr,
    loading,
    languages,
    languagesTV,
    allPerm,
    userPerm : {
      ...userPerm,
      blocked
    }
  }
}